var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLockSvg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "lock 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M34.1666 15H31.6666V11.6666C31.6666 5.23359 26.4331 0 20 0C13.5669 0 8.33336 5.23359 8.33336 11.6666V15H5.83336C5.37273 15 5 15.3727 5 15.8334V36.6667C5 38.5051 6.49492 40 8.33336 40H31.6667C33.5051 40 35 38.5051 35 36.6666V15.8334C35 15.3727 34.6273 15 34.1666 15ZM22.4952 32.408C22.5212 32.6432 22.4455 32.8792 22.2877 33.0559C22.1298 33.2324 21.9035 33.3334 21.6667 33.3334H18.3334C18.0966 33.3334 17.8703 33.2324 17.7124 33.0559C17.5545 32.8793 17.4788 32.6433 17.5049 32.408L18.0306 27.6807C17.177 27.0598 16.6667 26.0775 16.6667 25C16.6667 23.1616 18.1616 21.6666 20.0001 21.6666C21.8385 21.6666 23.3334 23.1616 23.3334 25C23.3334 26.0775 22.8232 27.0598 21.9695 27.6807L22.4952 32.408ZM26.6666 15H13.3334V11.6666C13.3334 7.9907 16.3241 5 20 5C23.6759 5 26.6666 7.9907 26.6666 11.6666V15Z",
    fill: "#34A853"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLockSvg);
export default __webpack_public_path__ + "static/media/LockSvg.a59b1ad385bddf45edae0246e0c23d19.svg";
export { ForwardRef as ReactComponent };